export const Endpoints = {
	auth: {
		private: "private/auth",
		signup: "private/auth/sign-up"
	},
	purchaserAuth: {
		private: "private/auth/purchaser",
		admin:"private/auth"
	},
	brand: {
		private: "private/backoffice/brand",
		all: "private/backoffice/supplier-brand/catalog/supplier",
		best: "private/backoffice/supplier/best",
		public: "public/backoffice/brand",
		limit: 'private/backoffice/purchaser-brand-limit',
		realtime:'private/backoffice/po-processing',
		region:'private/backoffice/region',
		inventory:'private/backoffice/inventory',
		status:'private/backoffice/supplier/card',
		inventory:"private/backoffice/purchaser-brand/catalog"
	},
	categories: {
		private: "private/backoffice/catalog/brandCategory"
	},
	cardType: {
		private: "private/backoffice/giftcard/type",
		public: "public/backoffice/giftcard/type",
		error:   "private/auth",
	},
	supplier:{
		private: "private/backoffice/supplier",
		brand: "private/backoffice/supplier-brand",
		priority: "private/backoffice/supplier-brand-priority",
		card: "private/backoffice/supplier/card",
		cardCatalog: "private/backoffice/supplier-gift-card-catalog",
		layout: "private/backoffice/supplierLayout",
		file: "private/backoffice/po-processing",
		details:"private/backoffice/supplier/all/brand"
	},
	catalog:{
		country:{
			private: "private/backoffice/country"
		},
		contactType:{
			private: "private/backoffice/catalog/supplierContactType"
		},
		paymentOption:{
			private: "private/backoffice/catalog/paymentOption"
		},
		currency:{
			private: "private/backoffice/catalog/currency"
		},
		download:{
			private:"private/backoffice/supplier/catalog/download"
		},
		region:"private/backoffice/catalog/region",
		infocountry:"private/backoffice/catalog/country"

		
	},
	purchaser:{
		private: "private/backoffice/purchaser",
		brand: "private/backoffice/purchaser-brand",
		bestBrand: "private/backoffice/purchaser-best-brand-detail",
		card: "private/backoffice/purchaser/card",
		api: 
			{
				private: "private/purchaser/api",
				user: "private/purchaser/api/user"
			},
		history: "private/backoffice/historic/sales-orders" ,
		notifiactionList: "private/backoffice/purchaser/allNotificationContact",
		payment:"private/backoffice/transactions",
		funds:"private/backoffice/purchaser/funds",
		thirdParty:"private/backoffice/purchaser/third-party-info",
		Notification:"private/auth/notification",
		userInfo:"private/auth"
	},
	purchaseOrder: {
		supplier: "private/backoffice/purchase-order/shopping-cart",
		private: "private/backoffice/purchase-order",
		processing: "private/backoffice/po-processing",
		history: "private/backoffice/historic/purchase-orders",
		order: "private/backoffice/purchase-order/purchase-source",
		brand:"private/backoffice/purchase-order/purchase-source-type",
		historyAll: "private/backoffice/historic/all",
		invoice:"private/backoffice/transactions",
		billing:"private/backoffice/purchaser",
		orderSeacrh:"private/backoffice",
		orderRef:"private/backoffice/inventory/download/inventory"
		
	},
	representativeUsers: {
		private: "private/backoffice/representative-users",
		user: "private/backoffice/user"
	},
	inventory:{
		private: "private/backoffice/inventory",
		brand: "private/backoffice/inventory-threshold/threshold",
		deno: "private/backoffice/giftcard/type",
		supplier:"private/backoffice/supplier"

	},
	file:{
		private: "private/backoffice/file"
	},
	tradein:{
		public: "public/auth"
	},
	shoppingCart:{
		internal: "private/backoffice/internal/shopping-cart"
	},
	shoppingCartPurchaseOrder: {
		private: "private/backoffice/shopping-cart"
	},
	skuMapping:{
		private: "private/backoffice/sku-mapping",
		supplier: "private/backoffice/sku-mapping/supplier"
	},
	pogress:{
		private:"private/backoffice/po-processing/non-api",
		nonApi:"private/backoffice/purchase-order/detail/non-api"
	}
};
